// This file was auto generated by resource-sync tools.

import ar_translation from './ar/translation.json';
import en_translation from './en/translation.json';
import ptBR_translation from './pt-BR/translation.json';
import zh_translation from './zh/translation.json';
import zhHK_translation from './zh-HK/translation.json';

const resources = {
    'namespaces': [{
        'i18nConfig': {"env":"test","apiKey":"cb1575a166f345489d543674572915f6","projectId":3,"namespaceId":"7n19apwpqm","namespaceName":"translation"},
        'localeInfos': [{"locale":"ar","version":109},{"locale":"en","version":128},{"locale":"pt-BR","version":14},{"locale":"zh","version":132},{"locale":"zh-HK","version":118}]
    }],
    'ar': {
        translation: ar_translation
    },
    'en': {
        translation: en_translation
    },
    'pt-BR': {
        translation: ptBR_translation
    },
    'zh': {
        translation: zh_translation
    },
    'zh-HK': {
        translation: zhHK_translation
    }
};

export default resources;